import React, { PureComponent } from "react";

import Template from "./Login.jsx";
import { post } from "../../util/fetch.js";
import { Provider as AlertProvider } from "../alert/AlertController.jsx";
import "./styles.styl";

export const Context = React.createContext({});

class LoginOverlayController extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active,
      data: {},
      errors: {},
    };
    this.handlers = {
      onChange: this.onChange.bind(this),
      onLoginButtonClick: this.onLoginButtonClick.bind(this),
      onSubmit: this.onSubmit.bind(this),
    };
  }

  onChange(e) {
    const { name, value } = e.target;
    const { data, errors } = this.state;
    this.setState({
      data: {
        ...data,
        [name]: value,
      },
      errors: {
        ...errors,
        message: undefined,
        [name]: undefined,
      },
    });
  }

  onSubmit(e) {
    e.preventDefault();
    this.submit();
  }

  onLoginButtonClick(e) {
    e.preventDefault();
    this.submit();
  }

  submit() {
    const { data } = this.state;
    const { login } = this.props;
    login(data)
      .then(() => this.props.onLoginClick())
      .catch((e) => {
        this.setState({ errors: e.data });
      });
  }

  render() {
    return <Template {...this.props} {...this.state} {...this.handlers} />;
  }
}

const ProvidedLoginController = AlertProvider(LoginOverlayController);
export default ProvidedLoginController;

export class LoginProviderController extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: props.isAuthenticated,
      customer: props.delivery && props.delivery.subscription.customer,
      logout: this.logout.bind(this),
      login: this.login.bind(this),
      setIsAuthenticated: this.setIsAuthenticated.bind(this),
    };
  }

  login(data) {
    const { customer } = this.state;

    return post("/api/login/" + customer.id, { body: data }).then(() =>
      this.onLogin(),
    );
  }

  logout() {
    return post("/api/logout").then(() => this.onLogout());
  }

  onLogin() {
    this.setState({ isAuthenticated: true });
  }

  setIsAuthenticated(isAuthenticated) {
    this.setState({ isAuthenticated });
  }

  onLogout() {
    this.setState({ isAuthenticated: false });
  }

  render() {
    return (
      <Context.Provider value={this.state}>
        {this.props.children}
      </Context.Provider>
    );
  }
}

export function Provider(C) {
  return function Provided(props) {
    return (
      <LoginProviderController {...props}>
        <C {...props} />
      </LoginProviderController>
    );
  };
}

export function Authenticate(C) {
  return function Authenticated(props) {
    return (
      <Context.Consumer>
        {({ isAuthenticated, overlayActive, ...rest }) => {
          return <C {...props} isAuthenticated={isAuthenticated} {...rest} />;
        }}
      </Context.Consumer>
    );
  };
}
